import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import EnquiryForm from "@/components/site/EnquiryForm";
import { usePageMeta } from "@/components/site/SEO";
import { CONTACT_INTRO, SITE } from "@/content/site";

export default function StartYourJourney() {
  usePageMeta(
    "Start Your Journey",
    "Tell us about your school, your students and what you are curious to explore. Enquire about a Wandering Glider Experiences journey.",
  );

  return (
    <>
      <PageHero
        eyebrow="Start Your Journey"
        title="Let's find the right journey for you."
        intro={CONTACT_INTRO}
      />

      <section className="container-x pb-24 sm:pb-32" data-testid="enquiry-section">
        <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr] lg:gap-20">
          <Reveal>
            <EnquiryForm />
          </Reveal>
          <Reveal delay={0.15}>
            <aside className="space-y-10 lg:sticky lg:top-32">
              <div className="border border-line bg-white p-8" data-testid="privacy-note">
                <h2 className="text-lg font-semibold">How we use your details</h2>
                <p className="mt-3 text-base leading-relaxed text-ink/75">
                  The details you share in this form are used to respond to your enquiry. We do not
                  send marketing emails, and there is no newsletter to subscribe to.
                </p>
              </div>
              <div className="border border-line bg-white p-8" data-testid="contact-aside">
                <h2 className="text-lg font-semibold">Prefer to talk or write?</h2>
                <p className="mt-3 text-base leading-relaxed text-ink/75">
                  You can also reach us by phone or email.
                </p>
                <a
                  href={SITE.phoneHref}
                  data-testid="aside-phone-link"
                  className="mt-4 block text-lg font-medium text-pine underline decoration-pine/40 underline-offset-4 transition-colors hover:decoration-pine"
                >
                  {SITE.phone}
                </a>
                <a
                  href={SITE.emailHref}
                  data-testid="aside-email-link"
                  className="mt-3 block text-lg font-medium text-pine underline decoration-pine/40 underline-offset-4 transition-colors hover:decoration-pine"
                >
                  {SITE.email}
                </a>
              </div>
              <p className="text-sm leading-relaxed text-ink/50" data-testid="registered-office">
                Registered office: Wandering Glider Experiences LLP, Shamshabad, Hyderabad,
                Telangana - 500052
              </p>
            </aside>
          </Reveal>
        </div>
      </section>
    </>
  );
}
